
document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("wimCanalEticoOverlay");
  const closeBtn = overlay?.querySelector(".wim-canal-etico__close");
  const acceptBtn = overlay?.querySelector(".wim-canal-etico__accept");

  if (!overlay) return;

  const closePopup = () => {
    overlay.classList.remove("is-active");
    overlay.addEventListener(
      "transitionend",
      () => {
        if (!overlay.classList.contains("is-active")) {
          overlay.setAttribute("aria-hidden", "true");
        }
      },
      { once: true }
    );
  };

  acceptBtn?.addEventListener("click", closePopup);
  closeBtn?.addEventListener("click", () => { window.location.href = "/"; });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") window.location.href = "/";
  });
});

(function () {
  var ANON_EMAIL = 'canaletico@jgc.es';

  function setReactInputValue(input, value) {
    var nativeSet = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    if (nativeSet) {
      nativeSet.call(input, value);
    } else {
      input.value = value;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Busca elementos recursivamente en Shadow DOMs anidados
  function deepQuery(root, selector) {
    var el = root.querySelector(selector);
    if (el) return el;

    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        el = deepQuery(all[i].shadowRoot, selector);
        if (el) return el;
      }
    }
    return null;
  }

  function initFormLogic(container) {
    if (container.dataset.wimLogicInitialized) return true;

    var root = container.shadowRoot || container;

    // Selectores exactos basados en el DOM real de Shopify Forms:
    // - Email: input#email (type="text", data-testid="field-email")
    // - Checkbox: input[name="custom#anonimo"] (type="checkbox")
    var emailInput = deepQuery(root, 'input#email, input[data-testid="field-email"]');
    var checkbox = deepQuery(root, 'input[name="custom#anonimo"]');

    if (!emailInput || !checkbox) return false;

    container.dataset.wimLogicInitialized = 'true';

    var originalEmail = emailInput.value || '';
    var lastCheckedState = null;

    function applyAnonymous(isChecked) {
      // Re-buscar por si React recreó los elementos
      var email = deepQuery(root, 'input#email, input[data-testid="field-email"]');
      if (!email) return;

      // El wrapper es el div._formFieldContainer padre del input de email
      var wrapper = email.closest('div[class*="formFieldContainer"]') || email.parentElement;

      if (isChecked) {
        // Guardar email original solo si no es ya el genérico
        if (email.value && email.value !== ANON_EMAIL) {
          originalEmail = email.value;
        }
        setReactInputValue(email, ANON_EMAIL);
        if (wrapper) wrapper.style.setProperty('display', 'none', 'important');
      } else {
        var restoreValue = (originalEmail && originalEmail !== ANON_EMAIL) ? originalEmail : '';
        setReactInputValue(email, restoreValue);
        if (wrapper) wrapper.style.removeProperty('display');
      }
    }

    // Polling cada 250ms: detecta cambios del checkbox y refuerza el ocultado
    setInterval(function () {
      var cb = deepQuery(root, 'input[name="custom#anonimo"]');
      if (!cb) return;

      var currentState = cb.checked;

      if (currentState !== lastCheckedState) {
        lastCheckedState = currentState;
        applyAnonymous(currentState);
      } else if (currentState) {
        // Reforzar ocultado en caso de que React re-renderice
        var email = deepQuery(root, 'input#email, input[data-testid="field-email"]');
        if (email) {
          var wrapper = email.closest('div[class*="formFieldContainer"]') || email.parentElement;
          if (wrapper && wrapper.style.display !== 'none') {
            wrapper.style.setProperty('display', 'none', 'important');
          }
          // Reforzar valor por si React lo limpió
          if (email.value !== ANON_EMAIL) {
            setReactInputValue(email, ANON_EMAIL);
          }
        }
      }
    }, 250);

    return true;
  }

  function injectStyleInShadowRecursively(root) {
    if (!root.getElementById('wim-fix-mensaje-label')) {
      var s = document.createElement('style');
      s.id = 'wim-fix-mensaje-label';
      s.textContent = [
        'textarea[name="custom#mensaje"]:not(:focus) ~ label[for="custom#mensaje"] { top: 20px !important; }',
        'form > div textarea:focus + label[for="custom#mensaje"],',
        'form > div textarea:not(:placeholder-shown) + label[for="custom#mensaje"] { padding: 0 !important; }',
        'input[type="checkbox"] {',
        '  appearance: auto !important;',
        '  -webkit-appearance: checkbox !important;',
        '  opacity: 1 !important;',
        '  width: 18px !important;',
        '  height: 18px !important;',
        '  position: static !important;',
        '  margin-right: 8px !important;',
        '  display: inline-block !important;',
        '  pointer-events: auto !important;',
        '  cursor: pointer !important;',
        '}',
        'fieldset label { cursor: pointer !important; }',
        'legend { display: none !important; }',
        '@media (max-width: 749px) {',
        '  #app-embed > div { justify-content: stretch !important; }',
        '  #app-embed > div > section, [data-sizing="form-wrapper"] { width: 100% !important; min-width: 100% !important; }',
        '}'
      ].join(' ');
      root.appendChild(s);
    }

    var elements = root.querySelectorAll('*');
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].shadowRoot) {
        injectStyleInShadowRecursively(elements[i].shadowRoot);
      }
    }
  }

  function applyFixes() {
    var embed = document.querySelector('shopify-forms-embed');
    if (!embed) return false;

    var root = embed.shadowRoot;
    if (root) {
      injectStyleInShadowRecursively(root);
      return initFormLogic(embed);
    }

    return false;
  }

  var attempts = 0;
  var maxAttempts = 60;
  var interval = setInterval(function () {
    attempts++;
    if (applyFixes() || attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 500);

})();



